import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=208343cf"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports